import { create } from 'zustand';

type NavSearchStore = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  clearSearchQuery: () => void;
};

export const useNavSearchStore = create<NavSearchStore>()((set) => ({
  searchQuery: '',
  setSearchQuery: (query: string) => set({ searchQuery: query }),
  clearSearchQuery: () => set({ searchQuery: '' }),
}));
